import React from 'react'
import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

type FileIconProps = {
    name: string,
    color?: string,
    fileType?: string

}

function FileIcon(props: FileIconProps) {
    const { color, name, fileType } = props
    return (
        <ContainerIcon fileType={fileType}>
            <Icon {...props} className={fileType} color={color}>
                <i className={"fas fa-file "}>
                    <span>{name}</span>
                </i>
            </Icon>
        </ContainerIcon>
    )
}

export default FileIcon

const ContainerIcon = styled.div`
    ${(props) => {
        return props.fileType && css`
                        .seedsdrilling,
                        .dadosbasicosdrilling {
                            > i {
                                color: #0092d3;
                            }
                        }
                        /* avaliação */
                        .seedsassessment,
                        .dadosbasicosassessment {
                            > i {
                            color: #fc7632;
                            }
                        }
                        /* completação */
                        .seedscompletion,
                        .dadosbasicoscompletion {
                            > i {
                            color: #009856;
                            }
                        }
                        /*executado*/
                        .seedsasbuilt,
                        .dadosbasicosasbuilt {
                            > i {
                            color: #ebb62f;
                            }
                        }
                        .matrizcomplexity {
                            > i {
                            color: #00ced3;
                            }
                        }
                        .simentarstudy {
                            > i {
                            color: #00ced3; 
                            }
                        }
                        .wellcostdesign {
                            > i {
                            color: #00ced3;
                            }
                        }
                        .weelcostcsb {
                            > i {
                            color: #00ced3;
                            }
                        }
                        .simcarrstudy,
                        .csbncsb {
                            > i {
                            color: #3a8352;
                            }
                        }
                `
        }

    }
    

`

const Icon = styled.div`
    > i {
            font-size: 24px;
            margin: 0 10px 0 5px;
            position: relative;
            color: ${(props) => props.color ? props.color : "#000"};
            > span {
                position: absolute;
                bottom: 2px;
                left: 2px;
                color: white;
                font-size: 9px;
                font-style: normal;
                font-family: ${theme['font-semibold']};
                font-weight: 600;
            }
        }
`
